import React from "react";
import { Link } from "react-router-dom";
import s from './Letter.module.scss';
import { useTranslation } from 'react-i18next';


export const Letter = () => {
    const { t } = useTranslation()

    return (
        <div className={s.wrapper}>
        <div>
            <div className={s.container}>
            
                <div className={s.content}>
                    <div className={s.birds}></div>
                    <div className={s.formForgot}>
                        <div className={s.formTittle}>{t('sent_letter_message')}</div>
                        <div className={s.formText}>{t('email_arrived_message')}</div>
                        <div className={s.button}>
                            <Link to='/'>
                                <button className={s.signBtn} type="submit">{t('back_to_main_page')}</button></Link>
                        </div>
                        <div className={s.formText}>{t('letter_time_message')}</div>
                    </div>
                </div>
            </div>
            <div className={s.upperCloud}></div>
            <div className={s.uuderCloud}></div>
        </div>
        
    </div>
    )
}